import { createSelector } from 'reselect';

import { FetchGroupsSuggestListFilter } from '../api/grid/EntitiesDataProvider';
import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { CampaignType } from '../typings/domain';
import { GdShowConditionTypeInput } from '../typings/graphql-grid';
import {
    CampaignAndGroupSelectorEntityToSelectType,
    CampaignAndGroupSelectorState
} from '../typings/state';
import { State } from '../typings/state';

export const selectGroupsSuggestListFilter = createSelector(
    (state: State) => state.grid.campaignAndGroupSelector,
    (state: State, nameContains: string) => nameContains,
    (state: State, nameContains: string, campaignSelected: SelectorItems) =>
        campaignSelected,
    (
        campaignAndGroupSelector: CampaignAndGroupSelectorState,
        nameContains: string,
        campaignSelected: SelectorItems
    ): FetchGroupsSuggestListFilter => {
        const { entityToSelectType } = campaignAndGroupSelector;

        // Отрезаем группы с "Профилем пользователя" для CPM при добавлении фраз
        if (
            entityToSelectType ===
                CampaignAndGroupSelectorEntityToSelectType.PHRASE &&
            campaignSelected.type === CampaignType.CPM_BANNER
        ) {
            return {
                campaignId: campaignSelected.id,
                nameContains: nameContains,
                showConditionTypeIn: [GdShowConditionTypeInput.KEYWORD]
            };
        }

        return {
            campaignId: campaignSelected.id,
            nameContains: nameContains
        };
    }
);
